import React, { useState, useEffect } from 'react';
import { withLocale } from '../../hocs/withLocale';

const loadScript = (src, callback) => {
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.onload = () => callback();
  document.head.appendChild(script);
};

export const GoogleMapsLoader = (Component) => {
  return withLocale((props) => {
    const [isScriptLoaded, setIsScriptLoaded] = useState(false);
    const { currentLanguage } = props;

    useEffect(() => {
      const scriptUrl = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAFWaIFuhPGyo-GouevLR_EFu4-_NYS6Bo&language=${currentLanguage}&libraries=places`;
      loadScript(scriptUrl, () => setIsScriptLoaded(true));
    }, [currentLanguage]);

    if (!isScriptLoaded) {
      return null; // Or render a loader/spinner, etc.
    }

    return <Component {...props} />;
  });
};
